/*
 * @format
 */

import { put, takeLatest, delay, call, all } from 'redux-saga/effects';

import * as types from '../action-types';
import { Auth } from 'aws-amplify';
import jsonapi, { PENDING_DSR_COMMAND } from '../api/jsonapi';
import Logger from '../../components/Logger';

let jsonApi = null;
let abortController = null;

function* removeCommandAfterTtl(pendingCommand) {
  const now = new Date();
  const ttl = new Date(pendingCommand.ttl * 1000);
  const scheduledAt = ttl - now;

  yield delay(scheduledAt);

  yield put({
    type: types.REMOVE_PENDING_DSR_COMMANDS,
    pendingDsrCommand: pendingCommand,
  });
}

function* maybeGetPendingDsrCommands(action) {
  const homes = action.data?.data || [];
  const dsrEnabled = homes.some(home => home?.hpi?.dsrEnabled);

  if (dsrEnabled) {
    yield getPendingDsrCommands();
  }
}

function* getPendingDsrCommands(action) {
  const callback = action?.callback;

  if (abortController) {
    abortController.abort();
  }

  abortController = new AbortController();

  try {
    const response = yield jsonApi.findAll(PENDING_DSR_COMMAND, {
      opts: { signal: abortController.signal },
    });

    const data = response?.data;

    if (data) {
      yield put({
        type: types.PENDING_DSR_COMMANDS_RECEIVED,
        pendingDsrCommands: data,
      });

      if (callback) {
        callback();
      }

      const calls = data.map(pendingCommand =>
        call(removeCommandAfterTtl, pendingCommand),
      );

      yield all(calls);
    }
  } catch (err) {
    Logger.error('Error fetching pending DSR commands:', err);

    if (callback) {
      callback(err);
    }
  }

  abortController = null;
}

function* pendingDsrCommands(params) {
  jsonApi = params?.jsonApi || jsonapi(Auth);

  yield all([
    takeLatest(
      [types.HOMES_MESSAGE_RECEIVED, types.WEBSOCKET_HELLO_MESSAGE_RECEIVED],
      maybeGetPendingDsrCommands,
    ),
    takeLatest(types.FETCH_PENDING_DSR_COMMANDS, getPendingDsrCommands),
  ]);
}

export default pendingDsrCommands;
